import { render, staticRenderFns } from "./BeamlineDashboard.vue?vue&type=template&id=1bcae9ac&scoped=true&"
import script from "./BeamlineDashboard.vue?vue&type=script&lang=js&"
export * from "./BeamlineDashboard.vue?vue&type=script&lang=js&"
import style0 from "./BeamlineDashboard.vue?vue&type=style&index=0&id=1bcae9ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcae9ac",
  null
  
)

export default component.exports